(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bennett-finish-products-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    const sort = event.target.closest('[data-finish-products-sort]');
    if (!sort) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    window.location.assign(url.toString());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bennett-finish-products-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-bennett-finish-results-header]').forEach(async (header) => {
        const searchParams = new URLSearchParams(window.location.search);
        const finish = searchParams.get('finish') || searchParams.get('filter.v.option.finish');
        const target = header.querySelector('[data-finish-results-name]');
        const caption = header.querySelector('[data-finish-results-caption]');
        const clearPendingState = () => document.documentElement.classList.remove('bennett-finish-filter-pending');
        const normalizeFinishName = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, '');
        const isSelectable = normalizeFinishName(finish) === 'tbd';
        const displayFinish = isSelectable ? header.dataset.selectableLabel : finish;
        if (finish && target) target.textContent = displayFinish;
        if (finish && caption) caption.textContent = displayFinish;

        if (!finish || header.dataset.colorFilterActive === 'true') {
          clearPendingState();
          return;
        }

        const matchingValue = [...header.querySelectorAll('[data-finish-filter-value]')].find(
          (value) => normalizeFinishName(value.dataset.finishFilterValue) === normalizeFinishName(finish)
        );

        if (!matchingValue?.dataset.finishFilterUrl) {
          const colorParam = [...searchParams.keys()].find((key) => key.includes('color-pattern'));
          const colorValue = colorParam ? searchParams.get(colorParam) : null;
          const currentSwatch = header.querySelector('.bennett-finish-results-header__swatch');
          if (colorParam && colorValue && currentSwatch) {
            const sourceUrl = new URL('/collections/all', window.location.origin);
            sourceUrl.searchParams.set(colorParam, colorValue);
            sourceUrl.searchParams.set('view', 'finish-products');
            sourceUrl.searchParams.set('finish', finish);
            sourceUrl.searchParams.set('status', 'all-products');
            try {
              const response = await fetch(sourceUrl, { credentials: 'same-origin' });
              if (response.ok) {
                const sourceDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
                const sourceSwatch = sourceDocument.querySelector('.bennett-finish-results-header__swatch');
                if (sourceSwatch) currentSwatch.replaceChildren(...[...sourceSwatch.childNodes].map((node) => node.cloneNode(true)));
              }
            } catch {}
          }
          clearPendingState();
          return;
        }

        const filterUrl = new URL(matchingValue.dataset.finishFilterUrl, window.location.origin);
        filterUrl.searchParams.set('view', 'finish-products');
        filterUrl.searchParams.set('finish', finish);
        window.location.replace(filterUrl);
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
    else initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
